import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=bc286538&scoped=true&"
import script from "./Tickets.vue?vue&type=script&lang=js&"
export * from "./Tickets.vue?vue&type=script&lang=js&"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=bc286538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc286538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc286538')) {
      api.createRecord('bc286538', component.options)
    } else {
      api.reload('bc286538', component.options)
    }
    module.hot.accept("./Tickets.vue?vue&type=template&id=bc286538&scoped=true&", function () {
      api.rerender('bc286538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/Tickets.vue"
export default component.exports